export enum EDateFormat {
  DATE = 'YYYY-MM-DD',
  DATE_TIME = 'YYYY-MM-DD HH:mm:ss',
  DATE_TIME_SHORT = 'YYYY-MM-DD HH:mm',
  TIME = 'HH:mm:ss',
  MONTH = 'MMMM YYYY',
  DAY_COMPACT = 'D.M.YY',
}
